import React from 'react';
import { Clock3, Sparkles } from 'lucide-react';

import { Card } from '../../ui/card';
import { Badge } from '../../ui/badge';

export default function ComingSoonTab({
  eyebrow = 'Command Center lane',
  title,
  description,
  highlights = [],
}) {
  return (
    <div className="space-y-6">
      <Card className="border border-slate-200 bg-gradient-to-br from-white via-slate-50 to-[#edf6f4] p-6 dark:border-white/10 dark:bg-gradient-to-br dark:from-[#1c2127] dark:via-[#171b20] dark:to-[#11161a]">
        <div className="flex flex-wrap items-center gap-3">
          <Badge className="border-aqua/20 bg-aqua/10 text-cyan-800 dark:border-aqua/20 dark:bg-aqua/10 dark:text-aqua">
            <Clock3 className="mr-1.5 h-3.5 w-3.5" />
            Coming soon
          </Badge>
          <p className="text-[11px] font-semibold uppercase tracking-[0.24em] text-slate-500 dark:text-gray-400">
            {eyebrow}
          </p>
        </div>

        <h2 className="mt-4 text-2xl font-semibold text-slate-900 dark:text-white">
          {title}
        </h2>
        <p className="mt-3 max-w-3xl text-sm leading-6 text-slate-600 dark:text-gray-300">
          {description}
        </p>
      </Card>

      <Card className="border-slate-200 bg-white/90 p-6 dark:border-white/10 dark:bg-white/[0.03]">
        <div className="flex items-center gap-2">
          <Sparkles className="h-4 w-4 text-aqua" />
          <h3 className="text-sm font-semibold uppercase tracking-[0.22em] text-slate-600 dark:text-gray-300">
            Planned scope
          </h3>
        </div>
        <div className="mt-4 grid gap-3 lg:grid-cols-3">
          {(highlights || []).map((item) => (
            <div
              key={item}
              className="rounded-[1.1rem] border border-slate-200 bg-slate-50/80 px-4 py-3 text-sm text-slate-700 dark:border-white/10 dark:bg-white/[0.04] dark:text-gray-300"
            >
              {item}
            </div>
          ))}
        </div>
      </Card>
    </div>
  );
}
